type IconProps = React.HTMLAttributes<SVGElement>;

export const GroupUserIcon = (props: IconProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="17" height="12" viewBox="0 0 17 12" fill="none" {...props}>
    <path
      d="M9.63694 7.42821C9.45277 7.24045 9.24884 7.07629 9.0293 6.93359C9.24884 7.07629 9.45381 7.24152 9.63694 7.42821Z"
      fill="currentColor"
    />
    <path
      d="M13.4728 6.5957H10.4762C10.3222 6.5957 10.1703 6.60643 10.0215 6.62789C10.1765 6.76844 10.3243 6.91758 10.4606 7.08066C10.6052 7.25233 10.7342 7.4358 10.8507 7.62571H13.4728C14.7921 7.62571 15.8648 8.73189 15.8648 10.0924V11.8616H16.8637V10.0924C16.8637 8.16431 15.3425 6.5957 13.4728 6.5957Z"
      fill="currentColor"
    />
    <path
      d="M7.15527 6.375C7.81689 6.37507 8.43729 6.5654 8.9668 6.89258C8.98845 6.90539 9.00864 6.91975 9.0293 6.93359H9.02734C9.24688 7.07629 9.45158 7.23998 9.63574 7.42773C9.70337 7.4964 9.76771 7.56757 9.8291 7.6416C9.84549 7.66167 9.86155 7.68303 9.87793 7.70312H9.88086C10.3845 8.33293 10.6895 9.13886 10.6895 10.0176V11.8613H9.64941V10.0176C9.64941 9.33534 9.39005 8.71416 8.96777 8.25391C8.72638 7.99104 8.43231 7.7802 8.10352 7.63965C7.81133 7.51533 7.49207 7.44731 7.15625 7.44727H4.0332C3.64624 7.44731 3.27976 7.53813 2.95312 7.70117C2.84407 7.75474 2.74035 7.81711 2.64062 7.88672C2.60733 7.91032 2.57425 7.93431 2.54199 7.95898C2.47771 8.00819 2.41654 8.06061 2.35742 8.11621C2.32829 8.14303 2.2986 8.1722 2.27051 8.20117C2.2144 8.25904 2.16029 8.32057 2.10938 8.38379C1.93156 8.60581 1.78917 8.85915 1.69141 9.13477C1.64883 9.25258 1.61577 9.3747 1.59082 9.5C1.57417 9.58369 1.56106 9.67003 1.55273 9.75586C1.54442 9.8427 1.54004 9.92957 1.54004 10.0186V11.9014H0.5V10.0186C0.500044 8.01016 2.08457 6.37512 4.03223 6.375H7.15527Z"
      fill="currentColor"
    />
    <path
      d="M2.95283 7.70117C2.84358 7.75589 2.73953 7.81705 2.63965 7.88679C2.73953 7.81705 2.84358 7.75482 2.95283 7.70117Z"
      fill="currentColor"
    />
    <path
      d="M1.59117 9.5C1.57452 9.58369 1.56203 9.66845 1.55371 9.75535C1.56203 9.66952 1.57452 9.58369 1.59117 9.5Z"
      fill="currentColor"
    />
    <circle cx="5.22381" cy="2.53143" r="2.05407" stroke="currentColor" strokeWidth="0.954711" />
    <circle cx="11.299" cy="2.53143" r="2.05407" stroke="currentColor" strokeWidth="0.954711" />
  </svg>
);
